import { navLinks } from '@/mocks/cinemaData';

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-film-line text-lg" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-semibold text-background-50">秋霞影院在线观看</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-300">
              一个围绕「秋霞影院在线观看」整理访问方式与内容导览的中文信息页，涵盖手机版、电脑版、网页版、APP 下载以及手机浏览器观看与在线看的说明。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-wider text-accent-300">页面分区</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2 text-sm">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-background-200 transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold uppercase tracking-wider text-accent-300">内容说明</h3>
            <ul className="mt-4 space-y-2 text-sm leading-relaxed text-background-300">
              <li className="flex gap-2">
                <i className="ri-information-line mt-0.5 text-accent-300" aria-hidden="true" />
                本站为信息整理页面，不提供音视频内容与下载链接。
              </li>
              <li className="flex gap-2">
                <i className="ri-shield-check-line mt-0.5 text-accent-300" aria-hidden="true" />
                请通过合规、来源清楚的渠道使用相关服务。
              </li>
              <li className="flex gap-2">
                <i className="ri-time-line mt-0.5 text-accent-300" aria-hidden="true" />
                各端功能与体验可能随来源变化，以实际打开页面为准。
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-700 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 秋霞影院在线观看 · 信息整理页</p>
          <p>手机版 · 电脑版 · 网页版 · APP 下载 · 浏览器观看 · 在线看</p>
        </div>
      </div>
    </footer>
  );
}